/**
 * Labstep
 *
 * @module core/Number/Circle
 * @desc Number in a circle
 */

import classnames from 'classnames';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { INumberCircleProps } from './types';

export const NumberCircle: React.FC<INumberCircleProps> = ({
  small,
  number,
  primary,
  complete,
}) => (
  <span
    className={classnames(styles.numberCircle, {
      [styles.small]: small,
      [styles.primary]: primary,
      [styles.complete]: complete,
    })}
    data-testid="number-circle"
  >
    {complete ? <Icon name="check" /> : number}
  </span>
);
